import { render, staticRenderFns } from "./AutoGenModal.vue?vue&type=template&id=6d180dda&"
import script from "./AutoGenModal.vue?vue&type=script&lang=js&"
export * from "./AutoGenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports